/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
// import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { FiFilter } from 'react-icons/fi';
import color from '../../constants/color';
import IOSSwitch from '../IOsSwitch';
import {
  Container,
  Title,
  Header,
  OnPress,
  Divider,
  // ContainerLoading,
} from './styles';

interface Props {
  id?: string;
  title: string;
  childrens: JSX.Element;
  hasFilter: boolean;
  openFilter?: Function;
  isSwitch?: boolean;
  switchValue?: boolean;
  onChangeSwitch?: Function;
  isLoading?: boolean;
}

const CardContainerCommon: React.FC<Props> = ({
  id,
  title,
  childrens,
  hasFilter,
  openFilter,
  isSwitch,
  switchValue,
  onChangeSwitch,
  isLoading,
}) => (
  <Container>
    <Header>
      <Title>{title}</Title>
      {hasFilter && (
        <>
          <OnPress onClick={() => openFilter && openFilter(true)}>
            <FiFilter size={16} color={color.blue} />
          </OnPress>
        </>
      )}
      {isSwitch && !isLoading && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <IOSSwitch
            check={switchValue || false}
            onClick={() => onChangeSwitch && onChangeSwitch(id, switchValue)}
          />
          <div style={{ fontFamily: 'Inter' }}>
            {switchValue ? 'Ativo' : 'Inativo'}
          </div>
        </div>
      )}
    </Header>
    <Divider />
    {childrens}
  </Container>
);
export default CardContainerCommon;
